import {
    createDataActionFactory,
    Feature,
    createActionFactory,
    ThunkDispatch,
    createThunk,
} from '../../../../shared';
import type { Dispatch } from 'redux';
import { renewGroupErrorNotification } from '../../user/groups/notificationBarActions';
import renewGroup from '../../../dataLayer/ows/groups/renewGroup';
import { getPackageState } from '../../../../appstate';
import { HubState, packageStateKey } from '../../../state';

export const renewGroupClickedAction = createActionFactory<{
    groupId: string;
    hubPersonaId: string;
}>('renewGroupClickedAction', Feature.UnifiedGroups);

export const renewGroupCompletedAction = createDataActionFactory<
    { groupId: string; groupSmtp: string; hubPersonaId: string },
    { groupId: string; groupSmtp: string; groupName: string; hubPersonaId: string }
>(
    'renewGroupCompletedAction',
    Feature.UnifiedGroups,
    action => ({ groupId: action.payload.groupId }),
    action => ({ groupId: action.payload.groupId })
);

export const renewGroupInExoCompletedAction = createDataActionFactory<
    { groupId: string; groupSmtp: string; hubPersonaId: string },
    { groupId: string; groupSmtp: string; groupName: string; hubPersonaId: string }
>(
    'renewGroupInExoCompletedAction',
    Feature.UnifiedGroups,
    action => ({ groupId: action.payload.groupId }),
    action => ({ groupId: action.payload.groupId })
);

export const renewGroupAction = (dispatch: Dispatch) => (
    groupId: string,
    groupSmtp: string,
    groupName: string,
    hubPersonaId: string,
    isRetry?: boolean,
    isRenewFromLpc?: boolean
) => {
    renewGroup(groupId, groupSmtp, !!isRenewFromLpc)
        .then(response => {
            dispatch(renewGroupCompletedAction.success({ groupId, groupSmtp, hubPersonaId }));
        })
        .catch((error: Error) => {
            dispatch(
                renewGroupCompletedAction.error({ groupId, groupSmtp, groupName, hubPersonaId })
            );
            renewGroupErrorNotification(dispatch)(
                groupSmtp,
                groupId,
                groupName,
                isRetry,
                isRenewFromLpc,
                hubPersonaId
            );
        });
};

export const lpcRenewGroup = (hubPersonaId: string) =>
    createThunk('LpcRenewGroupCompleted', (dispatch: ThunkDispatch, getState: () => {}): void => {
        const packageState = getPackageState<HubState>(getState(), packageStateKey);

        if (packageState) {
            const groupsMap = packageState.appState.data.groupsHubState.unifiedGroupsMap;

            if (groupsMap?.[hubPersonaId]) {
                const group = groupsMap[hubPersonaId];

                renewGroup(group.externalDirectoryObjectId, group.emailAddress, true)
                    .then(() => {
                        dispatch(
                            renewGroupInExoCompletedAction.success({
                                groupId: group.externalDirectoryObjectId,
                                groupSmtp: group.emailAddress,
                                hubPersonaId: group.hubPersonaId,
                            })
                        );
                    })
                    .catch(() => {
                        dispatch(
                            renewGroupInExoCompletedAction.error({
                                groupId: group.externalDirectoryObjectId,
                                groupSmtp: group.emailAddress,
                                groupName: group.displayName,
                                hubPersonaId: group.hubPersonaId,
                            })
                        );
                        renewGroupErrorNotification(dispatch)(
                            group.externalDirectoryObjectId,
                            group.emailAddress,
                            group.displayName,
                            false,
                            true,
                            group.hubPersonaId
                        );
                    });
            }
        }
    });
